(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["\"@gnosis.pm/safe-react-gateway-sdk\""] = factory();
	else
		root["\"@gnosis.pm/safe-react-gateway-sdk\""] = factory();
})(self, function() {
return 